// xs: 0,
// sm: 600,
// md: 900,
// lg: 1200,
// xl: 1536,
import { useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";

const useMQ = () => {
	const theme = useTheme();
	const isExtraLargeOrLower = useMediaQuery(theme.breakpoints.down("xl")); // < 1536
	const isLargeOrLower = useMediaQuery(theme.breakpoints.down("lg")); // < 1200
	const isMediumOrLower = useMediaQuery(theme.breakpoints.down("md")); // < 900
	const isSmallOrLower = useMediaQuery(theme.breakpoints.down("sm")); // < 600
	const isExtraSmallOrLower = useMediaQuery(theme.breakpoints.down("xs"));

	const isExtraLargeOrUpper = useMediaQuery(theme.breakpoints.up("xl")); // > 1536
	const isLargeOrUpper = useMediaQuery(theme.breakpoints.up("lg")); // > 1200
	const isMediumOrUpper = useMediaQuery(theme.breakpoints.up("md")); // > 900
	const isSmallOrUpper = useMediaQuery(theme.breakpoints.up("md")); // > 600
	const isExtraSmallOrUpper = useMediaQuery(theme.breakpoints.up("xs")); // > 0

	return {
		isExtraLargeOrLower,
		isExtraLargeOrUpper,
		isExtraSmallOrLower,
		isExtraSmallOrUpper,
		isLargeOrLower,
		isLargeOrUpper,
		isMediumOrLower,
		isMediumOrUpper,
		isMicro: isSmallOrLower,
		isMobile: isMediumOrLower,
		isSmallOrLower,
		isSmallOrUpper,
		theme,
	};
};

export default useMQ;
